/* This is the EMIS Staff Salary components */

<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <div>
      <table border="1px;" cellspacing="0px;">
        <tbody>
          <tr>
            <td style="width: 150px; text-align: center; vertical-align: middle" rowspan="2">ស្ថានភាពគ្រូបង្រៀន</td>
            <td style="width: 100px; text-align: center" colspan="2">មត្តេយ្យកម្រិតទាប</td>
            <td style="width: 100px; height: 25px; text-align: center" colspan="2">មត្តេយ្យកម្រិតមធ្យម</td>
            <td style="width: 100px; height: 25px; text-align: center" colspan="2">មត្តេយ្យកម្រិតខ្ពស់</td>
            <td style="width: 100px; height: 25px; text-align: center" colspan="2">មត្តេយ្យកម្រិតចម្រុះ</td>
            <td style="width: 100px; height: 25px; text-align: center" colspan="2">សរុប</td>
          </tr>
          <tr style="height: 25px; text-align: center">
            <td style="width: 50px">សរុប</td>
            <td style="width: 50px">ស្រី</td>
            <td style="width: 50px">សរុប</td>
            <td style="width: 50px">ស្រី</td>
            <td style="width: 50px">សរុប</td>
            <td style="width: 50px">ស្រី</td>
            <td style="width: 50px">សរុប</td>
            <td style="width: 50px">ស្រី</td>
            <td style="width: 50px">សរុប</td>
            <td style="width: 50px">ស្រី</td>
          </tr>
          <tr
            v-for="(value, row) in d2.length"
            :key="row"
            style="height: 25px; text-align: left"
          >
            <td style="width: 150px; height: 25px">{{ d2[row] }}</td>
            <td style="width: 60px; height: 25px">
              <numberinput v-model="data[row].dt[0]" style="width: 50px; text-align: center;" />
            </td>
            <td style="width: 60px; height: 25px">
              <numberinput v-model="data[row].dt[1]" style="width: 50px; text-align: center;" />
            </td>
            <td style="width: 60px; height: 25px">
              <numberinput v-model="data[row].dt[2]" style="width: 50px; text-align: center;" />
            </td>
            <td style="width: 60px; height: 25px">
              <numberinput v-model="data[row].dt[3]" style="width: 50px; text-align: center;" />
            </td>
            <td style="width: 60px; height: 25px">
              <numberinput v-model="data[row].dt[4]" style="width: 50px; text-align: center;" />
            </td>
            <td style="width: 60px; height: 25px">
              <numberinput v-model="data[row].dt[5]" style="width: 50px; text-align: center;" />
            </td>
            <td style="width: 60px; height: 25px">
              <numberinput v-model="data[row].dt[6]" style="width: 50px; text-align: center;" />
            </td>
            <td style="width: 60px; height: 25px">
              <numberinput v-model="data[row].dt[7]" style="width: 50px; text-align: center;" />
            </td>
            <td class="td-white">
              <strong>{{ col1[row] | blank }}</strong>
            </td>
            <td class="td-white">
              <strong>{{ col2[row] | blank }}</strong>
          </td>
          </tr>
          <!-- Total Row data, last two columns do not draw and sum -->
          <tr style="height: 25px; text-align: center">
            <td style="width: 150px; height: 25px">សរុប</td>
            <td
              v-for="(value, col) in totalRow.length"
              :key="col"
              style="width: 50px; height: 25px"
            >
              {{ totalRow[col] }}
            </td>
            <td class="td-white">
              <strong>{{ tCol1 | blank }}</strong>
            </td>
            <td class="td-white">
              <strong>{{ tCol2 | blank }}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import { d2 } from "@/utils/ascf/commonConfig.js";
import NumberInput from "@/components/common/NumberInput.vue";
export default {
  props: ["data", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      d2: d2,
    };
  },
  computed: {
    // need to update the total staff in json data
    totalRow: function () {
      let result;
      let d = this.data;
      let ldata = this.data.length - 1;

      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (ind < ldata) {
            // do summing 0 to last - 1 only (last is sum array)
            r[i] = (r[i] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      // update the total row array in JSON
      d[ldata].dt.forEach(function (b, i) {
        d[ldata].dt[i] = result[i];
      });
      return result;
    },
    col1: function () {
      let result;
      let d = this.data;

      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 2 === 0) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
    col2: function () {
      let result;
      let d = this.data;

      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 2 === 1) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
    /* tCol1, tCol2 are the total of total row and column */
    tCol1: function () {
      return (
        this.totalRow[0] +
        this.totalRow[2] +
        this.totalRow[4] +
        this.totalRow[6]
      );
    },
    tCol2: function () {
      return (
        this.totalRow[1] +
        this.totalRow[3] +
        this.totalRow[5] +
        this.totalRow[7]
      );
    },
  },
  filters: {
    blank: function (value) {
      if (value == 0) return "";
      return value;
    },
  },
};
</script>
<style scoped>
.td-white {
  width: 60px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
  background-color: white;
}
</style>